import React from 'react';
import { Row, Col, Button, Input, Space } from 'antd';
import { 
  MenuOutlined, 
  SearchOutlined, 
  FilterOutlined, 
  DownloadOutlined, 
  ReloadOutlined, 
  PlusOutlined 
} from '@ant-design/icons';

interface MobileHeaderComponentProps {
  title: string;
  onMenuClick?: () => void;
  onSearch?: (value: string) => void;
  onFilterClick?: () => void;
  onExportClick?: () => void;
  onRefreshClick?: () => void;
  onCreateClick?: () => void;
  searchPlaceholder?: string;
  showSearch?: boolean;
  showFilter?: boolean;
  showExport?: boolean;
  showRefresh?: boolean;
  showCreate?: boolean;
  onSearchToggle?: () => void;
  isSearchOpen?: boolean;
}

export const MobileHeaderComponent: React.FC<MobileHeaderComponentProps> = ({
  title,
  onMenuClick,
  onSearch,
  onFilterClick,
  onExportClick,
  onRefreshClick,
  onCreateClick,
  searchPlaceholder = 'Search...',
  showSearch = true,
  showFilter = true,
  showExport = true,
  showRefresh = true,
  showCreate = true,
  onSearchToggle,
  isSearchOpen = false,
}) => {
  return (
    <div style={{ 
      background: '#ffffff', 
      padding: '12px 16px', 
      borderBottom: '1px solid #f0f0f0',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <Row justify="space-between" align="middle" gutter={[12, 0]}>
        {/* Left Side - Menu and Title */}
        <Col>
          <Row align="middle" gutter={[12, 0]}>
            <Col>
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={onMenuClick}
                style={{
                  fontSize: '18px',
                  color: '#000',
                  padding: '4px',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              />
            </Col>
            <Col>
              <div style={{ 
                fontSize: '20px', 
                fontWeight: 'bold', 
                color: '#000',
                lineHeight: '1.2'
              }}>
                {title}
              </div>
            </Col>
          </Row>
        </Col>

        {/* Right Side - Action Icons */}
        <Col>
          <Space size="small">
            {showSearch && (
              <Button
                type="text"
                icon={<SearchOutlined />}
                onClick={onSearchToggle}
                style={{
                  fontSize: '16px',
                  color: isSearchOpen ? '#1890ff' : '#666',
                  padding: '4px',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              />
            )}
            
            {showFilter && (
              <Button
                type="text"
                icon={<FilterOutlined />}
                onClick={onFilterClick}
                style={{
                  fontSize: '16px',
                  color: '#666',
                  padding: '4px',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              />
            )}
            
            {showExport && (
              <Button
                type="text"
                icon={<DownloadOutlined />}
                onClick={onExportClick}
                style={{
                  fontSize: '16px',
                  color: '#666',
                  padding: '4px',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              />
            )}
            
            {showRefresh && (
              <Button
                type="text"
                icon={<ReloadOutlined />}
                onClick={onRefreshClick}
                style={{
                  fontSize: '16px',
                  color: '#666',
                  padding: '4px',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              />
            )}
            
            {showCreate && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={onCreateClick}
                style={{
                  fontSize: '16px',
                  padding: '4px',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#1890ff',
                  border: 'none',
                  boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)'
                }}
              />
            )}
          </Space>
        </Col>
      </Row>

      {/* Search Bar (only show when search is open) */}
      {showSearch && isSearchOpen && (
        <div style={{ marginTop: '12px' }}>
          <Input
            placeholder={searchPlaceholder}
            onChange={(e) => onSearch?.(e.target.value)}
            style={{
              borderRadius: '20px',
              fontSize: '14px'
            }}
            prefix={<SearchOutlined style={{ color: '#999' }} />}
            autoFocus
          />
        </div>
      )}
    </div>
  );
};
